'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const Globals = require('../../../app/globals');
const Strings = require('../../../app/shared/Strings');

const ActivityActions = require('../actions/ActivityActions');
const ActivityStore = require('../stores/activity_store_reflux');
const VoiceStore = require('../stores/VoiceStore');
const ChatbotSystem = require('../util/ChatbotSystem');

import TopNav from './DashboardNew/Menu/TopNav';
import ErrorBox from './common/ErrorBox';
import IFrame from './IFrame';

const propTypes = {
    shareId: PropTypes.string.isRequired,
};

const defaultProps = {};

class ActivityShareView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fatalError: null,
            getShareLinkUrlId: null,
            linkUrl: null,
        };

        this.iframe = React.createRef();
        this.getShareLinkUrl = this.getShareLinkUrl.bind(this);
        this.unsubscribes = [ActivityStore.listen(this.onActivityStoreChange.bind(this))];
    }

    _handleMessage=(e)=>{
        const msg = e.originalEvent.data;
        const origin = e.originalEvent.origin;

        if (!GlobalConfig.DevMode && origin.indexOf('muzzylane.com') === -1) {
            return;
        }

        const targetWindow = this.iframe && this.iframe.current && this.iframe.current.contentWindow;

        if (this.chatbotSystem) {
            let handled = this.chatbotSystem.handleMessage(msg,targetWindow);
            if (handled) {
                return;
            }
        }
        if (this.voiceSystem) {
            let handled = this.voiceSystem.handleMessage(msg,targetWindow);
            if (handled) {
                return;
            }
        }
    }

    componentDidMount() {
        $(window).off('message', this._handleMessage).on('message', this._handleMessage);
        this.getShareLinkUrl(this.props.shareId);
    }

    componentWillUnmount() {
        $(window).off('message', this._handleMessage);
        if (this.voiceSystem) {
            this.voiceSystem.shutDown();
        }
        if (this.chatbotSystem) {
            this.chatbotSystem.shutDown();
        }

        this.unsubscribes.forEach(u => u());
    }

    getShareLinkUrl(shareId) {
        const getShareLinkUrlId = uuid.v4();
        this.setState({ getShareLinkUrlId: getShareLinkUrlId }, () => {
            ActivityActions.getShareLinkUrl(getShareLinkUrlId, {
                shareId: shareId,
            });
        });
    }

    onActivityStoreChange(state) {
        if (state.action.id === this.state.getShareLinkUrlId) {
            if (state.action.error) {
                this.setState({ getShareLinkUrlId: null, fatalError: state.action.error });
            }
            else {
                let data = state.shareLinkData[this.props.shareId];
                if (data && data.permissions) {
                    let userData = {...data, shareId:this.props.shareId }; // should include activityId and channelId
                    let hasPolly = data.permissions[Globals.users.account_features.useVoiceSynthesis];
                    let hasElevenLabs = data.permissions[Globals.users.account_features.useVoiceSynthesisElevenLabs];
                    let hasCartesia = data.permissions[Globals.users.account_features.useVoiceSynthesishasCartesia];
                    if (hasPolly || hasElevenLabs || hasCartesia) {
                        this.voiceSystem = VoiceStore.getVoiceSystem(VoiceStore.SYSTEM_USAGE.SHARE_LINK,{userData});
                    }
                    //if (data.permissions[Globals.users.account_features.useChatBot]) {
                        // always create chatbotSystem. If it doesn't have permission it will respond with an error.
                        this.chatbotSystem = new ChatbotSystem({userData, usage: ChatbotSystem.SYSTEM_USAGE.SHARE_LINK});
                    //}
                }
                this.setState({ getShareLinkUrlId: null, linkUrl: state.shareLinkUrls[this.props.shareId] });
            }
        }
    }

    render() {
        return (
            <div className="preview-activity">
                <TopNav useMinLogo logoLinkDisable />
                {(!!this.state.fatalError) ?
                    <div className="text-centered">
                        <ErrorBox error={this.state.fatalError} />
                    </div>
                    :
                    <IFrame ref={this.iframe} url={this.state.linkUrl} />
                }
            </div>
        );
    }
}

ActivityShareView.propTypes = propTypes;
ActivityShareView.defaultProps = defaultProps;

const WrappedComponent = ActivityShareView;

function WrappedComponentWithUpdatedPropNames(props) {
    return (
        <WrappedComponent
            {...props}
            shareId={props.match.params.shareId}
        />
    );
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            shareId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;
